export default {
  planSet: 'email-landing',
  growthbookEnabled: false,
};
